/** MailLogDto: adaya gönderilen otomatik mail kaydı */
export type MailTriggerType = 'PROCESS_STEP' | 'QUESTION_CONDITION'

export type MailStatus = 'SENT' | 'FAILED' | 'SKIPPED'

export interface IMailLogModel {
  id: string
  recipient: string
  subject: string
  body: string
  mailTemplateName?: string | null
  triggerType: MailTriggerType
  /** Tetikleyen adımın adı ya da sorunun metni */
  triggerReference?: string | null
  status: MailStatus
  errorMessage?: string | null
  createdDate?: string
}

export const MAIL_TRIGGER_LABEL: Record<MailTriggerType, string> = {
  PROCESS_STEP: 'Süreç adımı',
  QUESTION_CONDITION: 'Soru koşulu',
}

export const MAIL_STATUS_LABEL: Record<MailStatus, string> = {
  SENT: 'Gönderildi',
  FAILED: 'Gönderilemedi',
  SKIPPED: 'Gönderilmedi',
}

export const MAIL_STATUS_BADGE: Record<MailStatus, string> = {
  SENT: 'badge-light-success',
  FAILED: 'badge-light-danger',
  SKIPPED: 'badge-light-warning',
}
